import { memo } from 'react'
import CategoryChip from '@/components/ui/CategoryChip'
import Meta from '@/components/ui/Meta'
import Link from 'next/link'
import CustomImage from '@/components/ui/CustomImage'
import { useAuth } from '@/contexts/AuthContext'
import { getHeroSubtitleHtml } from '@/lib/newsHtml'

const CHIP_LIMIT = 2

function parseNewsCategoryIds(data) {
    const ids = String(data?.categoryIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)

    if (data?.categoryId != null && data.categoryId !== '') {
        const primary = String(data.categoryId)
        if (!ids.includes(primary)) ids.unshift(primary)
    }
    return ids
}

const HeroCard = ({
    headline,
    subtitle,
    redirectUrl = "",
    advertisementImage = "",
    data = null
}) => {
    const { categories } = useAuth()
    const shortSubtitle = getHeroSubtitleHtml(subtitle)
    const categoryIds = parseNewsCategoryIds(data).slice(0, CHIP_LIMIT)

    return (
        <article className="group">
            <Link href={redirectUrl} className="block overflow-hidden rounded-lg min-w-0">
                <CustomImage
                    src={advertisementImage}
                    priority
                    width={1200}
                    height={675}
                    alt={headline}
                    className="w-full max-w-full aspect-[16/9] object-cover transition-transform duration-300 group-hover:scale-[1.02]"
                />
            </Link>

            <div className="hero-card-body">
                <div className="flex flex-wrap gap-2">
                    {categoryIds.map((id) => {
                        const category = categories.find((cat) => String(cat.id) === String(id))
                        if (!category?.name) return null
                        const slug = category.slug || category.nameEnglish?.toLowerCase() || ''
                        if (!slug) return null

                        return (
                            <CategoryChip
                                key={id}
                                name={category.name}
                                url={`/category/${slug}`}
                            />
                        )
                    })}
                </div>

                <Link href={redirectUrl}>
                    <h2 className="hero-card-headline">{headline}</h2>
                </Link>

                {shortSubtitle && (
                    <Link href={redirectUrl}>
                        <div
                            className="hero-card-subtitle line-clamp-2"
                            dangerouslySetInnerHTML={{ __html: shortSubtitle }}
                        />
                    </Link>
                )}

                <Meta
                    author="संपादकीय टीम"
                    data={data}
                />
            </div>
        </article>
    )
}

export default memo(HeroCard)
